import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { QueryError } from 'errors'
import { MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState } from 'mantine-react-table'
import { AuditLog, AuditLogTableItem } from 'types/audit'
import { Filterable } from 'types/index'

interface Params {
  columnFilters: MRT_ColumnFiltersState
  sorting: MRT_SortingState
  pagination: MRT_PaginationState
}

export function auditLogsQuery({ columnFilters, sorting, pagination }: Params) {
  const fetchUrl = new URL('/audit', window.location.origin)
  fetchUrl.searchParams.set('skip', `${pagination.pageIndex * pagination.pageSize}`)
  fetchUrl.searchParams.set('get', `${pagination.pageSize}`)
  fetchUrl.searchParams.set(
    'filters',
    JSON.stringify(columnFilters ?? []).replaceAll('"product.symbol"', '"productSymbol"')
  )
  fetchUrl.searchParams.set('sorting', JSON.stringify(sorting ?? []))

  return queryOptions<Filterable<AuditLog>, QueryError, Filterable<AuditLogTableItem>>({
    queryKey: ['auditLogs', fetchUrl],
    queryFn: async () => {
      return (await axios.get(fetchUrl.pathname + fetchUrl.search)).data
    },
    placeholderData: keepPreviousData,
    staleTime: 15_000,
    select: ({ data, total }) => {
      return {
        data: data.map((item) => ({
          ...item,
          createdAt: new Date(item.createdAt),
        })),
        total,
      }
    },
    refetchOnMount: 'always',
  })
}

export function useAuditLogs({ columnFilters, sorting, pagination }: Params) {
  return useQuery<Filterable<AuditLog>, QueryError, Filterable<AuditLogTableItem>>(
    auditLogsQuery({ columnFilters, sorting, pagination })
  )
}
